import React from 'react'

const Preloader = ({ variant = "gray" }) => {
    const variantClasses = {
        white: "border-Gray50",
        black: "border-Gray400",
        sorrell: "border-SorrellBrown4000",
    };

    return (
        <div className="flex items-center">
            <div className={`inline-block h-4 w-4 border-2 border-t-2 border-t-transparent 
                ${variantClasses[variant] || "border-Gray400"} 
                rounded-full animate-spin`}>
            </div>
        </div>
    )
}

export default Preloader